import {combineReducers} from '@reduxjs/toolkit';
import campaignOptimizationReducer from './campaignOptimization/campaignOptimization.slice';
import campaignIssuesReducer from './campaignIssues/campaignIssues.slice';
import campaignMediaVariationsReducer from './campaignMediaVariations/campaignMediaVariations.slice';
import campaignVariationsAnalysisReducer from './campaignVariationsAnalysis/campaignVariationsAnalysis.slice';
import campaignCommentsReducer from './campaignComments/campaignComments.slice';
import campaignIntegrationsReducer from './campaignIntegrations/campaignIntegrations.slice';
import campaignPreviewReducer from './campaignPreview/campaignPreview.slice';
import campaignBaseReducer from './campaignBase/campaignBase.slice';
import campaignTreeReducer from './campaignTree/campaignTree.slice';
import campaignLogicReducer from './campaignLogic/campaignLogic.slice';
import insightsPageReducer from './insightsPage/insightsPage.slice';
import adsetsTabReducer from './adsetsTab/adsetsTab.slice';
import adsTabReducer from './adsTab/adsTab.slice';

//will be added: base campaign page reducer

const campaignPageReducer = combineReducers({
  optimization: campaignOptimizationReducer,
  issues: campaignIssuesReducer,
  adsetsTab: adsetsTabReducer,
  adsTab: adsTabReducer,
  mediaVariations: campaignMediaVariationsReducer,
  variationsAnalysis: campaignVariationsAnalysisReducer,
  campaignComments: campaignCommentsReducer,
  campaignIntegrations: campaignIntegrationsReducer,
  campaignPreview: campaignPreviewReducer,
  campaignBase: campaignBaseReducer,
  campaignTree: campaignTreeReducer,
  campaignLogic: campaignLogicReducer,
  insightsPage: insightsPageReducer,
});

export default campaignPageReducer;
